import React from 'react';
import { ZeroStateButtonContainer } from '../ZeroState.styled';
var ButtonContainer = function (_a) {
    var renderButton = _a.renderButton;
    return renderButton ? React.createElement(ZeroStateButtonContainer, null, renderButton()) : React.createElement(React.Fragment, null);
};
export default ButtonContainer;
